// @ts-nocheck
import styled from 'styled-components';

export const DocumentSettingsStyle = styled.div`

  .documentSettings {
    &__title {
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeL};
      line-height: ${props => props.theme.fontSizeXL};
      letter-spacing: 0;
      padding-bottom: 24px;
    }

    &__container {
      background: ${props => props.theme.uiColors.tableBackground};

      &Columns {
        display: flex;
        flex-direction: column;
        row-gap: 32px;
        background: ${props => props.theme.uiColors.paginationBg};
        padding: 16px;
      }
    }
  }
`;
